// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Search40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Search40: FC<Search40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M32.856 34.818 22.051 24.013a9.417 9.417 0 0 1-2.902 1.653 10.261 10.261 0 0 1-3.515.597c-3.012 0-5.561-1.044-7.648-3.132-2.086-2.088-3.13-4.618-3.13-7.59 0-2.972 1.044-5.502 3.132-7.59 2.088-2.089 4.623-3.133 7.605-3.133 2.981 0 5.511 1.044 7.59 3.132 2.079 2.089 3.118 4.62 3.118 7.595a10.303 10.303 0 0 1-2.278 6.496l10.833 10.777-2 2Zm-17.25-11.333c2.2 0 4.069-.775 5.608-2.326 1.54-1.551 2.31-3.424 2.31-5.618 0-2.195-.77-4.067-2.31-5.618-1.54-1.551-3.408-2.327-5.608-2.327-2.214 0-4.096.776-5.647 2.327-1.55 1.55-2.325 3.423-2.325 5.618 0 2.194.775 4.067 2.325 5.618 1.55 1.55 3.433 2.326 5.647 2.326Z" />
        </svg>
    );
};

export default Search40;
